export var StatusCode;
(function (StatusCode) {
    StatusCode[StatusCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    StatusCode[StatusCode["NOT_FOUND"] = 404] = "NOT_FOUND";
    StatusCode[StatusCode["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
})(StatusCode || (StatusCode = {}));
export const ERROR_SEPERATOR_TOKEN = '___';
export class UiError extends Error {
    constructor(errorBody = 'An error occured') {
        if (typeof errorBody === 'string') {
            errorBody = {
                message: errorBody,
            };
        }
        if (Array.isArray(errorBody.message)) {
            errorBody.message = errorBody.message.join(ERROR_SEPERATOR_TOKEN);
        }
        super(errorBody.message);
        this.code = errorBody.statusCode;
    }
}
